import React from 'react';
import { Box, Typography } from '@mui/material';
import CodeEditor from '../shared/CodeEditor';

const CodeEditorStep = ({ config, response = {}, onChange, disabled }) => (
  <Box>
    <CodeEditor
      value={response.code || ''}
      onChange={(code) => onChange({ ...response, code })}
      language={config.language || 'python'}
      placeholder={config.placeholder}
      minRows={10}
      readOnly={disabled}
    />
    {config.language === 'sql' && (
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
        This step is for writing only — no execution. Save the run for the Evolve step.
      </Typography>
    )}
  </Box>
);

export default CodeEditorStep;
